import React, { useState, useContext } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import {
  Typography,
  Stepper,
  StepLabel,
  Step,
  StepConnector,
} from "@material-ui/core";
import Stepone from "../Register/Stepone";
import Steptwo from "../Register/Steptwo";
import Steptree from "../Register/Steptree";
import useReactRouter from "use-react-router";
import { LangContext } from "../../Context/Langcontext";

const useStyle = makeStyles((theme) => ({
  root: {
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      padding: "4rem 2rem 0px",
    },
    [theme.breakpoints.up("md")]: {
      padding: "5rem 5rem 0px",
    },
  },
}));

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    "& $line": {
      backgroundColor: "#e16733",
    },
  },
  completed: {
    "& $line": {
      backgroundColor: "#e16733",
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1,
  },
})(StepConnector);

const Registercomp = ({ setpage }) => {
  const classes = useStyle();
  const [step, setstep] = useState(0);
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const { history } = useReactRouter();
  const [input, setinput] = useState({
    email: "",
    password: "",
    cpassword: "",
    first_name: "",
    last_name: "",
    organization: "",
    address: "",
    tambon: "",
    amphoe: "",
    province: "",
    zipcode: "",
    country: "",
    phone: "",
    billing_info: {},
  });

  return (
    <div className={classes.root}>
      <Typography
        variant="h5"
        component="p"
        style={{ fontWeight: 600, padding: "1rem" }}
      >
        {lang.CreateAccessService}
      </Typography>
      <div style={{ display: "flex", width: "100%", justifyContent: "center" }}>
        <Typography variant="h6" component="p" style={{ fontWeight: 400 }}>
          {lang.Alreadyaccount} ?
        </Typography>
        <Typography
          variant="h6"
          component="p"
          color="primary"
          style={{ fontWeight: 400, paddingLeft: "1rem", cursor: "pointer" }}
          onClick={() => {
            setpage(0);
            history.push("/user/login");
          }}
        >
          {lang.Signin}
        </Typography>
      </div>

      <Stepper
        alternativeLabel
        activeStep={step}
        connector={<ColorlibConnector />}
      >
        <Step>
          <StepLabel>{lang.Account}</StepLabel>
        </Step>
        <Step>
          <StepLabel>{lang.PersonalInfo}</StepLabel>
        </Step>
        <Step>
          <StepLabel>{lang.BillingInfo}</StepLabel>
        </Step>
      </Stepper>

      {step === 0 ? (
        <Stepone
          setpage={setpage}
          setstep={setstep}
          input={input}
          setinput={setinput}
        />
      ) : step === 1 ? (
        <Steptwo setstep={setstep} input={input} setinput={setinput} />
      ) : step === 2 ? (
        <Steptree setstep={setstep} input={input} setinput={setinput} />
      ) : null}
    </div>
  );
};

export default Registercomp;
